<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import QuestionListIcon from "@/assets/widgetIcons/QuestionListIcon.vue";
import QuestionListDialog from "@/components/dialogs/QuestionListDialog.vue";
import {Dialog} from "quasar";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import {useQuestionList} from "./useQuestionList.ts";
import QuestionField = namaTypes.QuestionField;

const props = defineProps<{
  presenter: QuestionFieldsPresenter, questionField: QuestionField,
  doNotApplyThemeLayouts: boolean
}>()

const {selectedRowsNumber, isReferenceWithoutEntityType, resolveReferencedEntityType} = useQuestionList(props.presenter, props.questionField);

function onClick(e: Event) {
  if (isReferenceWithoutEntityType()) return;
  Dialog.create({
    component: QuestionListDialog,
    componentProps: {
      presenter: props.presenter,
      questionField: props.questionField,
      referencedEntityType: resolveReferencedEntityType(),
      clickEvent: e
    }
  });
}
</script>

<template>
  <WidgetContainer
    :field="questionField"
    :entityType="presenter.entityType"
    :isFieldDisabled="false"
    :isFieldRequired="questionField.required"
    :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
    :isInsideComposite="false">
    <template #icon>
      <NamaIcon :block="questionField" :presenter="presenter" class="tw-size-[22px] tw-text-[22px]"/>
    </template>
    <template v-slot:widget>
      <q-input outlined dense hide-bottom-space
               :id="questionField.id"
               autocomplete="off"
               readonly
               class="nama-customize-dense-input nama-focused-input nama-field-question-list"
               input-class="nama-input-class"
               :model-value="''">
        <template v-slot:prepend>
          <div class="tw-pl-2 tw-pr-1 tw-flex">
            <q-avatar square @click.stop.prevent="onClick" :title="Translator.translateId('select')"
                      class="nama-avatar-hover tw-cursor-pointer">
              <QuestionListIcon class="tw-w-[18px] tw-h-[18px] nama-widget-icon-hover nama-widget-icon"/>
            </q-avatar>
          </div>
          <q-chip
            clickable
            square
            @click.prevent.stop="onClick"
            class="nama-chip !tw-bg-namaBackground-dim-light hover:!tw-bg-gray-200 dark:!tw-bg-gray-600 dark:hover:!tw-bg-gray-500"
            :label="selectedRowsNumber"
            title="Selected Number"/>
        </template>
      </q-input>
    </template>
  </WidgetContainer>
</template>
